import { z } from "zod";

export const dropoffOptions = [
    'MEET_AT_DOOR',
    'MEET_AT_CURBSIDE',
    'LEAVE_AT_DOOR',
    'LEAVE_AT_LOBBY',
] as const;

// 'MEET_AT_MY_DOOR',
// 'MEET_OUTSIDE',
// 'MEET_IN_THE_LOBBY',
// 'LEAVE_AT_MY_DOOR',
// 'LEAVE_AT_BUILDING_RECEPTION',

export const addressSchema = z.object({
    addressId: z.string(),
    shippingName: z.string().min(1, ''),
    country: z.string().min(1, ''),
    state: z.string().optional(),
    phoneNumber: z.string().min(1, ''),
    address1: z.string().min(1, ''),
    address2: z.string().optional(),
    city: z.string(),//.optional(),
    postalCode: z.string().optional(),
    lat: z.number(),
    lng: z.number(),
    instructionsForPickupDelivery: z.string().max(280, '').optional(),
    instructionCategory: z.enum(dropoffOptions).optional(),
    // label: z.string().optional(),
    // icon: z.string().optional(),
    lastUpdatedTS: z.number().optional(),
})
export type AddressType = z.infer<typeof addressSchema>;


export const addressesSchema = z.record(z.string(), addressSchema).nullable();
export type AddressesType = z.infer<typeof addressesSchema>;

